import { render, staticRenderFns } from "./ResourceSummary.vue?vue&type=template&id=358cd460"
import script from "./ResourceSummary.vue?vue&type=script&lang=js"
export * from "./ResourceSummary.vue?vue&type=script&lang=js"
import style0 from "./ResourceSummary.vue?vue&type=style&index=0&id=358cd460&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports